import { router, useLocalSearchParams } from 'expo-router';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { ThemedText } from '@/components/themed-text';
import { PublicProfessionalPage } from '@/components/public-profile/professional-page';
import { GuestAppointmentsFab } from '@/components/schedule/guest-appointments-fab';
import { useAuthStore } from '@/store/authStore';
import { USER_ROLE } from '@/types/user-role';

/**
 * Página de um profissional da equipe: controlapag.com.br/@slug/professional/:id.
 * A marca é da loja, o conteúdo é dele.
 */
export default function PublicProfessionalRoute() {
  const { handle, providerId } = useLocalSearchParams<{
    handle: string;
    providerId: string;
  }>();
  const { user } = useAuthStore();

  const raw = typeof handle === 'string' ? handle : '';
  const slug = raw.startsWith('@') ? raw.slice(1) : null;
  const id = typeof providerId === 'string' ? providerId : '';

  // Cliente logado agenda pela área logada; o resto agenda como convidado, na
  // rota pública, já com o profissional escolhido.
  const onServicePress =
    user?.role === USER_ROLE.CLIENT
      ? (serviceId: string) =>
          router.push({
            pathname: '/(tabs)/(client)/service/[serviceId]',
            params: { serviceId },
          })
      : (serviceId: string) =>
          router.push({
            pathname: '/[handle]/service/[serviceId]' as any,
            params: { handle: raw, serviceId, professional: id },
          });

  if (!slug || !id) {
    return (
      <View className="flex-1 items-center justify-center gap-3 bg-background p-8">
        <Ionicons className="text-neutral-400" name="help-circle-outline" size={48} />
        <ThemedText className="text-center font-bold text-xl">Página não encontrada</ThemedText>
      </View>
    );
  }

  return (
    <View className="flex-1">
      <PublicProfessionalPage slug={slug} providerId={id} onServicePress={onServicePress} />
      <GuestAppointmentsFab />
    </View>
  );
}
